import { render, staticRenderFns } from "./TabbedView.vue?vue&type=template&id=1aef3d62"
import script from "./TabbedView.vue?vue&type=script&lang=js"
export * from "./TabbedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports